<div class="content-wrapper">
  @if (!loadingData()) {
    <mat-card class="content">
      <div class="content-header">
        <h2>
          Alle incasso's <span>({{ filteredDebitOrders().length }})</span>
        </h2>
        <div class="header-right">
          <mat-form-field class="mat-form-field-no-subscript">
            <mat-label class="placeholder">Zoeken</mat-label>
            <input
              matInput
              [ngModel]="searchQuery()"
              (ngModelChange)="searchQuery.set($event); onFilterChange('search', $event)"
            />
            <button
              mat-icon-button
              matSuffix
              aria-label="Zoekopdracht wissen"
              (click)="clearSearch(); $event.stopPropagation()"
            >
              <mat-icon>clear</mat-icon>
            </button>
          </mat-form-field>
          <button
            mat-icon-button
            aria-label="Sorteervolgorde wijzigen"
            (click)="toggleSortOrder()"
            [matTooltip]="sortOrder() === 'desc' ? 'Sorteer oplopend' : 'Sorteer aflopend'"
          >
            <mat-icon>{{ sortOrder() === 'desc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
          </button>
        </div>
      </div>

      <div class="card-wrapper">
        @for (debitOrder of filteredDebitOrders(); track debitOrder; let i = $index) {
          <mat-card class="card-order">
            <div class="card-title">
              <div class="title-text">{{ debitOrder.id }}</div>
              <div class="title-total">Totaal €{{ debitOrder.totalAmountToEarn }},00</div>
            </div>
            <div class="card-customer">
              <div
                class="customers-title"
                role="button"
                tabindex="0"
                aria-label="Passagierslijst in- of uitklappen"
                (click)="toggleMenu(debitOrder.id)"
                (keydown.enter)="toggleMenu(debitOrder.id)"
                (keydown.space)="$event.preventDefault(); toggleMenu(debitOrder.id)"
              >
                <p class="title-text">Passagiers ({{ debitOrder.customers.length }})</p>
                <mat-icon class="title-arrow">{{
                  isCollapsed()[debitOrder.id] === 'collapsed' ? 'expand_more' : 'expand_less'
                }}</mat-icon>
              </div>
              <div class="customers-list" [class.expanded]="isCollapsed()[debitOrder.id] === 'expanded'">
                <div class="customers-list-content">
                  <div class="info">
                    <p class="info-title">Naam</p>
                    @for (customer of debitOrder.customers; track customer) {
                      <p class="info-data">
                        {{ customer.name }}
                      </p>
                    }
                  </div>
                  <div class="info">
                    <p class="info-title">Betaald</p>
                    @for (customer of debitOrder.customers; track customer) {
                      <p class="info-data">
                        {{ customer.amount }}
                      </p>
                    }
                  </div>
                  <div class="info">
                    <p class="info-title">Credits</p>
                    @for (customer of debitOrder.customers; track customer) {
                      <p class="info-data">
                        {{ customer.credits }}
                      </p>
                    }
                  </div>
                </div>
              </div>
            </div>
            <div class="card-info">
              <p class="created-by">
                Aangemaakt door {{ debitOrder.createdBy }} op
                {{ moment(debitOrder.date).format('DD-MM-YYYY') }}
              </p>
              <div class="download-button">
                <button mat-flat-button class="secondary-color" (click)="downloadDebitOrder(i)">
                  <mat-icon>download</mat-icon>Download Incasso
                </button>
              </div>
            </div>
          </mat-card>
        }
        @if (filteredDebitOrders().length === 0 && searchQuery().trim() !== '') {
          <p class="no-results">Geen incasso’s gevonden voor deze zoekopdracht.</p>
        }
      </div>
    </mat-card>
  } @else if (loadingData()) {
    <div class="content-spinner">
      <mat-spinner></mat-spinner>
    </div>
  }
</div>
